import { Label, QuantityControl } from '@/components/ui'

interface QuantitySelectorProps {
  quantity: number
  onQuantityChange: (qty: number) => void
  min?: number
  max?: number
}

export function QuantitySelector({
  quantity,
  onQuantityChange,
  min = 1,
  max = 99,
}: QuantitySelectorProps) {
  return (
    <div className="flex items-center justify-between">
      <Label className="text-base font-semibold">Quantity</Label>
      <QuantityControl
        value={quantity}
        onDecrement={() => onQuantityChange(Math.max(min, quantity - 1))}
        onIncrement={() => onQuantityChange(Math.min(max, quantity + 1))}
        decrementDisabled={quantity <= min}
        incrementDisabled={quantity >= max}
        size="md"
        variant="outline"
      />
    </div>
  )
}
